<template>
  <section>
    <div class="mod-block">
      <h3 class="title">子商品档案</h3>
      <el-form ref="form" :model="form" label-width="80px" size="mini" class="mod-form">
        <el-form-item label="子商品编码" prop="subItem"
          :rules="[{validator: $validate.required, noRequired: form.subItemType},{validator: $validate.positiveInteger},{required: !form.subItemType}]">
          <el-input v-model="form.subItem" :disabled="!!form.subItemType" type="number"/>
        </el-form-item>
        <el-form-item label="子商品名称" prop="subItemDesc" required :rules="[{validator: $validate.required}]">
          <el-input v-model="form.subItemDesc"/>
        </el-form-item>
        <el-form-item label="编码类型" prop="subItemType"
          :rules="[{validator: $validate.required, noRequired: form.subItem},{required: !form.subItem}]">
          <el-select v-model="form.subItemType" :clearable="basicInfo.standardUom != 'KG'" :disabled="!!form.subItem">
            <el-option value="N" label="称重码" v-if="basicInfo.standardUom == 'KG'">称重码</el-option>
            <el-option value="Y" label="自定义编码" v-else></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>
<script>
  export default {
    inject: ['getMod', 'getComData'],
    data () {
      return {
        isFirst: true,
        basicInfo: {},
        form: {
          itemPackaged: this.isSimple ? 0 : 1, // 类型（0简单商品；1复杂商品）
          subItem: '', // 子商品编码
          subItemDesc: '', // 子商品名称
          subItemType: '' // 子商品类型
        }
      }
    },
    watch: {
      'form': {
        handler () {
          this.$refs.form.clearValidate()
        },
        deep: true
      }
    },
    computed: {
      isSimple () {
        return this.getComData().typeId == '2'
      }
    },
    mounted () {
      let $basicInfo = this.getMod('basicInfo')
      let subCommodityModel = this.getComData().editData.subCommodityModel
      $basicInfo.$on('updated', () => {
        if (this.isFirst && subCommodityModel) {
          this.form = Object.assign({}, subCommodityModel)
          this.isFirst = false
          return
        }
        this.form.subItem = ''
        this.form.subItemType = ''
        this.basicInfo = $basicInfo.form
        if (this.getComData().typeId === '1') {
          this.form.subItem = this.basicInfo.secondlevelCode
        }
        if (!this.form.subItemDesc) {
          this.form.subItemDesc = this.basicInfo.itemDesc
        }
        // 选中'称重码'
        if (this.basicInfo.standardUom === 'KG') {
          this.form.subItemType = 'N'
        }
        this.isFirst = false
      })
    }
  }
</script>
<style lang="scss" scoped>
  .mod-block {
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 10px 0px;
    overflow: hidden;
    margin-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-bottom: 10px;
      &::before {
        display: inline-block;
        content: "";
        height: 1em;
        border: 1px solid #3366ff;
        margin-right: 2px;
      }
    }
    .groups {
      overflow: hidden;
    }
  }
  .mod-form {
    .el-form-item {
      float: left;
      width: 190px;
      margin-bottom: 12px!important;
      border: 1px solid #ddd;
      padding: 3px;
      border-radius: 3px;
      margin-right: 10px;
    }
    /deep/ .label-text .el-form-item__label {
      line-height: 14px;
    }
    /deep/ .el-form-item__label {
      text-align: center;
      padding: 0 0 0 0;
    }
    /deep/ .el-input__inner {
      width: 100px;
    }
    /deep/ .el-form-item__content {
      font-size: 12px;
    }
    .mod-tag {
      background: #8400FF;
      color: #fff;
      border-radius: 4px;
      font-size: 12px;
      font-style: normal;
      padding: 2px;
    }
    .btns {
      float: left;
      padding-top: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/newpool/add/complex-combine/sub-commodity-archives.vue